<input
  class="timepicker-input"
  [placeholder]="placeholder"
  [ngClass]="class"
  [id]="identifier"
/>
